import PropTypes from 'prop-types';
import { createContext, useState } from "react";
import { obtenerHoraExtraGuardada } from '../../NominaHorasExtras/services/horas-extras-service';

const BtnEnviarHorasExtrasContext = createContext({});

export function BotonEnviarHorasExtrasProvider({ children }) {
    const [botonHorasExtras, setBotonHorasExtras] = useState(false);

    const actualizarBotonHorasExtras = async () => {
        const resp = await obtenerHoraExtraGuardada();
        setBotonHorasExtras(resp.data ?? false);
    };

    return (
        <BtnEnviarHorasExtrasContext.Provider
            value={{
                botonHorasExtras,
                setBotonHorasExtras,
                actualizarBotonHorasExtras,
            }}
        >
            {children}
        </BtnEnviarHorasExtrasContext.Provider>
    );
}

BotonEnviarHorasExtrasProvider.propTypes = {
    children: PropTypes.element
}

export default BtnEnviarHorasExtrasContext;
